import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  status: null,
  error: null,
  hasQuantityError: false,
  step: null,
  stepOptions: null,
  tiers: [],
  plans: [],
  minQuantity: null,
  currentQuantity: null,
  invitationsQuantity: null,
  featureKey: null,
  paywall: null,
  onSuccess: () => {}
}

const createSubscriptionSlice = createSlice({
  name: 'createSubscription',
  initialState,
  reducers: {
    moveToStep: (state, action) => {
      state.step = action.payload.step
      state.stepOptions = action.payload.stepOptions

      if (action.payload.stepOptions && action.payload.stepOptions.onSuccess) {
        state.onSuccess = action.payload.stepOptions.onSuccess
      }

      if (action.payload.stepOptions && action.payload.stepOptions.featureKey) {
        state.featureKey = action.payload.stepOptions.featureKey
      }

      if (action.payload.stepOptions && action.payload.stepOptions.paywall) {
        state.paywall = action.payload.stepOptions.paywall
      }
    },
    resetCreateSubscription: (state) => {
      const hasLoadedPlans = state.status === 'loaded' && state.plans.length > 0

      return {
        ...initialState,
        plans: state.plans,
        ...(hasLoadedPlans ? {
          status: state.status,
          tiers: state.tiers,
          currentQuantity: state.currentQuantity,
          minQuantity: state.minQuantity,
          deal: state.deal,
          dealMinQuantity: state.dealMinQuantity,
          dealMaxQuantity: state.dealMaxQuantity,
        } : {}),
      }
    },
    setError: (state, action) => {
      state.error = action.payload
      state.status = 'error'
    },
    setTier: (state, action) => {
      state.selectedTierId = action.payload
    },
    setInvitationsQuantity: (state, action) => {
      state.invitationsQuantity = action.payload
    },
    selectPlan: (state, action) => {
      state.planId = action.payload
    },
    loadPlans: (state, action) => {
      const { deal } = action.payload
      if (deal) {
        state.tiers = [{ id: deal.plan.tier, name: deal.plan.human_tier }]
        state.plans = [deal.plan]
        state.dealMinQuantity = deal.min_seat_count
        state.dealMaxQuantity = deal.max_seat_count
      } else {
        state.tiers = action.payload.tiers
        state.plans = action.payload.plans
      }
      state.currentQuantity = action.payload.current_quantity
      state.minQuantity = action.payload.min_quantity
      state.deal = deal
      state.status = 'loaded'
      state.error = null
    },
    resetOnSuccess: (state) => {
      state.onSuccess = initialState.onSuccess
    },
  }
})

export const {
  reducer,
  actions: {
    moveToStep,
    resetCreateSubscription,
    setError,
    setTier,
    setInvitationsQuantity,
    selectPlan,
    loadPlans,
    resetOnSuccess,
  }
} = createSubscriptionSlice
